// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"88de24f0","347":"978b5c93","536":"437cf9f4","714":"979e1304","850":"618ddd14","972":"2f1a7670"}[chunkId] + ".chunk.css";
};